import React from 'react'
import Plan from './Plan'

const Options = ({
  plans,
  product,
  quantity,
  selectedPlan = {},
  setShowOptionLoader,
}) => {
  const availablePlans = plans.map(plan => {
    let isOptionSelected = false
    if (selectedPlan && selectedPlan?.applied === true && selectedPlan?.planId === plan?.code) {
      isOptionSelected = true
    }

    return (
      <Plan
        key={`product:${product?.productId}|code:${plan.code}`}
        plan={plan}
        product={product}
        isOptionSelected={isOptionSelected}
        setShowOptionLoader={setShowOptionLoader}
        quantity={quantity}
      />
    )
  })

  return (<>{availablePlans.map(plan => plan)}</>)
}

export default Options
